import { render, staticRenderFns } from "./PieChart.vue?vue&type=template&id=fa20ccda&"
import script from "./PieChart.vue?vue&type=script&lang=js&"
export * from "./PieChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/zklink/web/zklink-explorer-web-build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fa20ccda')) {
      api.createRecord('fa20ccda', component.options)
    } else {
      api.reload('fa20ccda', component.options)
    }
    module.hot.accept("./PieChart.vue?vue&type=template&id=fa20ccda&", function () {
      api.rerender('fa20ccda', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Chart/PieChart.vue"
export default component.exports